import { useTranslation } from 'react-i18next';

import Collapse from 'components/collapse/Collapse';
import { MESSAGES_SENT_TO_GUESTS_TEMPLATE_ROWS } from '../SystemTemplatesTab.constants';
import SystemTemplatesTable from './common/SystemTemplatesTable';

const MessagesSentToGuestsSection = () => {
  const { t } = useTranslation();

  return (
    <Collapse
      data-testid="messages-sent-to-guests"
      defaultExpanded
      label={t('pageAutomations.systemTemplates.sections.messagesSentToGuests')}
      variant="card"
    >
      <SystemTemplatesTable
        data-testid="messages-sent-to-guests-table"
        data={MESSAGES_SENT_TO_GUESTS_TEMPLATE_ROWS}
      />
    </Collapse>
  );
};

export default MessagesSentToGuestsSection;
